(function(){
    angular
        .module('appback')
        .directive('ngSliderrangealt', sliderRangeAlt);

        sliderRangeAlt.$inject = ['$timeout'];
        function sliderRangeAlt($timeout){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/resultadopeticion/templateresultados?name=sliderrangealt.twig',
		          scope: {
	                  min: '=',
	                  max: '=',
	                  val: '='
	              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {

		            	scope.items = [];
		            	scope.fuera = false;
		            	
		            	//0 50 -> val 25
		            	for(var cont = 0;cont<100;cont++){
		            		scope.items.push(cont);
		            	}

		            	function cambiando(){
		            		//max 158	
		            		//min 145
		            		var max = parseFloat(scope.max.toString().replace(",","."));
			            	var min = parseFloat(scope.min.toString().replace(",","."));
			            	var val = parseFloat(scope.val.toString().replace(",","."));
		            		scope.fuera = false;
		            		var divisionInter = 20/(max-min/*13*/);//25
		            		//CADA PIXEL TIENE UN VALOR DE 1,538461538461538
			            	//var puntoCorte = scope.val / min;
			            	scope.puntoCorte = parseInt(((val-min) * divisionInter) + 40);

			            	if(parseFloat(val)>parseFloat(max) || parseFloat(val)<parseFloat(min)){
			            		scope.fuera = true;
			            	}

			            	/*100-145 * 1.53 + 40
			            	1	->	1.53*/



			            	//var punto = puntoCorte*divisionInter;

			            	//145 -> 0
			            	//val -> x

			            	//var diferencia = scope.min


		            		//console.log("CAMBIANDO SLID1", divisionInter);
			            	if(scope.puntoCorte<=0){
			            		scope.puntoCorte = 1;
			            	}
			            	if(scope.puntoCorte>=100){
			            		scope.puntoCorte = 99;
			            	}
		            	}

		            	scope.$watch('val', cambiando, true);

                        //console.log("anres",scope);
		            	//console.log("resultado");
			        });
		        }
          }
      }
})();